import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import Form from "react-bootstrap/Form"
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import styled from 'styled-components'
import { checkLoginAuth, setAuthToken, jumpToDashboard } from "utils/Auth"
import { apiURL } from 'config/globals'
import { decodeToken } from "react-jwt"
import retold_logo from 'images/retold_logo_trans_240.png'

const Styles = styled.div`
    form {
        width: 400px;
        min-height: 400px;
    }
`
const Login = () => {
    const [showLogin, setShowLogin] = useState(false)
    const [form, setForm] = useState({
        remember: true
    })
    const [errorMessage, setErrorMessage] = useState("")
    const navigate = useNavigate()

    useEffect(() => {
        const checkAuth = async() => {
            await checkLoginAuth(navigate)
            setShowLogin(true)
        }
        checkAuth()
    }, [])

    const handleChange = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
    }

    const login = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        try {
            const response = await axios.post(`${apiURL}/login`, form)

            if (!response.data.success) {
                setErrorMessage(response.data.error || response.data)
                return
            }
            
            setAuthToken(response.data.authToken)
            
            const decodedToken = decodeToken(response.data.authToken)
            jumpToDashboard(navigate, decodedToken.data.entityId)
        } catch (err) {
            console.error(err)
            setErrorMessage(err.message)
        }
    }

    return (
        <>
            {!!showLogin &&
                <>
                    <main className="loginPage full-width">
                        <Styles>
                            <div className="text-center">
                                <div>
                                    <img src={retold_logo} />
                                </div>
                                <h1>Portal Manager</h1>
                                <Form onSubmit={login}>
                                    <FloatingLabel controlId="userName" label="User Name" className="text-start mt-5">
                                        <Form.Control
                                            type="text"
                                            name="user"
                                            placeholder="User name"
                                            onChange={e => handleChange(e.target.name, e.target.value)}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="userPass" label="Password" className="text-start mt-3">
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            placeholder="Password"
                                            onChange={e => handleChange(e.target.name, e.target.value)}
                                        />
                                    </FloatingLabel>
                                    <Form.Check 
                                        type="checkbox"
                                        name="remember"
                                        label="Remember me"
                                        defaultChecked={form.remember}
                                        className="text-start mt-3"
                                        onChange={e => handleChange(e.target.name, e.target.value === "on")}
                                    />
                                    <div className="d-grid mt-4">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="my-4"
                                            size="lg"
                                            block="true"
                                        >
                                            Login
                                        </Button>
                                    </div>
                                    {errorMessage
                                        ? <Alert key="alert-error" variant="danger" className="text-start">
                                            {errorMessage}
                                        </Alert>
                                        : null
                                    }
                                </Form>
                            </div>
                        </Styles>
                    </main>
                </>
            }
        </>
    )
}
  
export default Login